export type TemplateLang = "en" | "ml";

export interface NotificationTemplate {
  key: string;
  label: string;
  content: Record<TemplateLang, { subject: string; body: string }>;
}

export const TEMPLATES: NotificationTemplate[] = [
  {
    key: "app_update",
    label: "App Update / New Release",
    content: {
      en: {
        subject: "Suprabhaatham App — New Update Available",
        body: `Dear Reader,

A new version of the Suprabhaatham app is now available. We've added new features and improved performance to give you a better reading experience.

What's new in this update:
- Performance improvements and bug fixes
- Enhanced reading experience
- New content sections

Please update your app to the latest version from the Play Store / App Store to enjoy these improvements.

Thank you for being with us.

— Team Suprabhaatham`,
      },
      ml: {
        subject: "സുപ്രഭാതം ആപ്പ് — പുതിയ അപ്‌ഡേറ്റ് ലഭ്യമാണ്",
        body: `പ്രിയ വായനക്കാരാ,

സുപ്രഭാതം ആപ്പിന്റെ പുതിയ പതിപ്പ് ഇപ്പോൾ ലഭ്യമാണ്. കൂടുതൽ മികച്ച വായനാനുഭവം നൽകുന്നതിനായി പുതിയ സവിശേഷതകളും പ്രകടന മെച്ചപ്പെടുത്തലുകളും ഉൾപ്പെടുത്തിയിട്ടുണ്ട്.

ഈ അപ്‌ഡേറ്റിലെ പുതിയത്:
- പ്രകടന മെച്ചപ്പെടുത്തലുകളും തകരാർ പരിഹരണങ്ങളും
- മെച്ചപ്പെട്ട വായനാനുഭവം
- പുതിയ ഉള്ളടക്ക വിഭാഗങ്ങൾ

ഈ മെച്ചപ്പെടുത്തലുകൾ ലഭ്യമാക്കാൻ Play Store / App Store-ൽ നിന്ന് ആപ്പ് അപ്‌ഡേറ്റ് ചെയ്യുക.

ഞങ്ങളോടൊപ്പം നിലനിൽക്കുന്നതിന് നന്ദി.

— സുപ്രഭാതം ടീം`,
      },
    },
  },
  {
    key: "new_feature",
    label: "New Feature Announcement",
    content: {
      en: {
        subject: "Introducing a New Feature on Suprabhaatham",
        body: `Dear Reader,

We are excited to introduce a brand-new feature on the Suprabhaatham app, designed to make your experience even better.

What you can do now:
- [Describe the feature here]
- [Add additional details]

Update your app to the latest version to start using it today.

We'd love to hear your feedback!

— Team Suprabhaatham`,
      },
      ml: {
        subject: "സുപ്രഭാതം ആപ്പിൽ പുതിയ സവിശേഷത",
        body: `പ്രിയ വായനക്കാരാ,

സുപ്രഭാതം ആപ്പിൽ പുതിയ സവിശേഷത അവതരിപ്പിക്കുന്നതിൽ ഞങ്ങൾക്ക് സന്തോഷമുണ്ട്. നിങ്ങളുടെ അനുഭവം കൂടുതൽ മികച്ചതാക്കാൻ വേണ്ടി രൂപകൽപ്പന ചെയ്തതാണിത്.

ഇപ്പോൾ നിങ്ങൾക്ക് ചെയ്യാൻ കഴിയുന്നത്:
- [സവിശേഷത ഇവിടെ വിശദീകരിക്കുക]
- [കൂടുതൽ വിശദാംശങ്ങൾ ചേർക്കുക]

ഇന്നുതന്നെ ഉപയോഗിക്കാൻ ആപ്പ് അപ്‌ഡേറ്റ് ചെയ്യുക.

നിങ്ങളുടെ പ്രതികരണങ്ങൾ ഞങ്ങൾക്ക് അറിയിക്കാം!

— സുപ്രഭാതം ടീം`,
      },
    },
  },
  {
    key: "bug_fix",
    label: "Bug Fix / Important Update",
    content: {
      en: {
        subject: "Important Update — Suprabhaatham App",
        body: `Dear Reader,

We have rolled out an important update for the Suprabhaatham app that fixes several issues reported by our users.

This update includes:
- Stability improvements
- Bug fixes for reported issues
- Security enhancements

Please update to the latest version at your earliest convenience.

Thank you for your patience and support.

— Team Suprabhaatham`,
      },
      ml: {
        subject: "പ്രധാനപ്പെട്ട അപ്‌ഡേറ്റ് — സുപ്രഭാതം ആപ്പ്",
        body: `പ്രിയ വായനക്കാരാ,

ഉപയോക്താക്കൾ റിപ്പോർട്ട് ചെയ്ത നിരവധി പ്രശ്നങ്ങൾ പരിഹരിക്കുന്ന ഒരു പ്രധാനപ്പെട്ട അപ്‌ഡേറ്റ് സുപ്രഭാതം ആപ്പിന് ലഭ്യമാക്കിയിട്ടുണ്ട്.

ഈ അപ്‌ഡേറ്റിൽ ഉൾപ്പെടുത്തിയിരിക്കുന്നത്:
- സ്ഥിരത മെച്ചപ്പെടുത്തലുകൾ
- റിപ്പോർട്ട് ചെയ്ത പ്രശ്നങ്ങൾക്ക് പരിഹാരങ്ങൾ
- സുരക്ഷാ മെച്ചപ്പെടുത്തലുകൾ

കഴിയുന്നത്ര വേഗം ഏറ്റവും പുതിയ പതിപ്പിലേക്ക് അപ്‌ഡേറ്റ് ചെയ്യുക.

നിങ്ങളുടെ ക്ഷമയ്ക്കും പിന്തുണയ്ക്കും നന്ദി.

— സുപ്രഭാതം ടീം`,
      },
    },
  },
  {
    key: "maintenance",
    label: "Maintenance Notice",
    content: {
      en: {
        subject: "Scheduled Maintenance Notification",
        body: `Dear Reader,

We will be performing scheduled maintenance on the Suprabhaatham app to improve performance and reliability.

Maintenance window: [Date & time]

During this period, certain features may be temporarily unavailable. We apologise for any inconvenience.

Thank you for your understanding.

— Team Suprabhaatham`,
      },
      ml: {
        subject: "ഷെഡ്യൂൾ ചെയ്ത മെയിന്റനൻസ് അറിയിപ്പ്",
        body: `പ്രിയ വായനക്കാരാ,

പ്രകടനവും വിശ്വാസ്യതയും മെച്ചപ്പെടുത്തുന്നതിനായി സുപ്രഭാതം ആപ്പിൽ ഷെഡ്യൂൾ ചെയ്ത മെയിന്റനൻസ് നടത്തുന്നതാണ്.

മെയിന്റനൻസ് സമയം: [തീയതിയും സമയവും]

ഈ സമയത്ത്, ചില സവിശേഷതകൾ താൽക്കാലികമായി ലഭ്യമാകാതിരിക്കാം. ഉണ്ടാകുന്ന അസൗകര്യങ്ങൾക്ക് ക്ഷമ ചോദിക്കുന്നു.

നിങ്ങളുടെ സഹകരണത്തിന് നന്ദി.

— സുപ്രഭാതം ടീം`,
      },
    },
  },
  {
    key: "general",
    label: "General Announcement",
    content: {
      en: {
        subject: "Important Announcement from Suprabhaatham",
        body: `Dear Reader,

[Write your announcement here.]

Thank you for being a part of the Suprabhaatham family.

— Team Suprabhaatham`,
      },
      ml: {
        subject: "സുപ്രഭാതത്തിൽ നിന്ന് പ്രധാനപ്പെട്ട അറിയിപ്പ്",
        body: `പ്രിയ വായനക്കാരാ,

[നിങ്ങളുടെ അറിയിപ്പ് ഇവിടെ എഴുതുക.]

സുപ്രഭാതം കുടുംബത്തിന്റെ ഭാഗമായതിന് നന്ദി.

— സുപ്രഭാതം ടീം`,
      },
    },
  },
];
